export default __webpack_public_path__ + "static/media/close_24px.6a2d1054.svg";